import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@codes/ui-kit/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@codes/ui-kit/components/ui/dialog';

export interface ReportModalProps {
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
    selectedValue: string;
    onValueChange: (value: string) => void;
    onSubmit: () => void;
}

export const ReportModal: React.FC<ReportModalProps> = ({
    isOpen,
    onOpenChange,
    selectedValue,
    onValueChange,
    onSubmit,
}) => {
    const { t } = useTranslation();

    const options = ['reasonAbuse', 'reasonAd', 'reasonIllegal', 'reasonInappropriate', 'reasonPrivacy', 'reasonSpam'];

    return (
        <Dialog open={isOpen} onOpenChange={onOpenChange}>
            <DialogContent className="p-0">
                <DialogHeader>
                    <DialogTitle>{t('agent.chat.reportTitle')}</DialogTitle>
                </DialogHeader>
                <div className="p-[18px]">
                    {options.map((option, index) => (
                        <div key={index} className="flex items-center">
                            <div className="relative border-b border-[#F4F5F5] w-full py-[14px]">
                                <input
                                    type="radio"
                                    id={`option-${index}`}
                                    name="report-reason"
                                    value={option}
                                    checked={selectedValue === option}
                                    onChange={() => onValueChange(option)}
                                    className="sr-only"
                                />
                                <label htmlFor={`option-${index}`} className="flex items-center cursor-pointer">
                                    <div
                                        className={`
                                        w-5 h-5 rounded-full border-2 border-background flex items-center justify-center transition-colors duration-200
                                        ${
                                            selectedValue === option
                                                ? 'border-primary dark:border-white'
                                                : 'border-gray-300 hover:border-primary'
                                        }
                                    `}
                                    >
                                        {selectedValue === option && (
                                            <div className="w-[10px] h-[10px] rounded-full bg-primary dark:bg-white"></div>
                                        )}
                                    </div>
                                    <span className="ml-2">{t(`agent.chat.${option}`)}</span>
                                </label>
                            </div>
                        </div>
                    ))}

                    <Button size="xl" className="w-full h-[50px] text-base mt-8" onClick={onSubmit}>
                        {t('agent.chat.submitReport')}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};
